import { render, staticRenderFns } from "./WelcomePageIndex1.vue?vue&type=template&id=1fcc554e"
import script from "./WelcomePageIndex1.vue?vue&type=script&lang=js"
export * from "./WelcomePageIndex1.vue?vue&type=script&lang=js"
import style0 from "./WelcomePageIndex1.vue?vue&type=style&index=0&id=1fcc554e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports